<template>
  <v-dialog v-model="showDialog" persistent scrollable max-width="900px" @keydown.esc="closeDialog">
    <v-card>
      <v-toolbar dark class="primary elevation-4">
        <h2 class="pt-1">{{guestName}}</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0 grey--text">
        <v-container fluid class="ma-0 pa-0">
          <v-layout row wrap>
            <v-flex xs12 md7 class="pa-4 elevation-3">
              <h4 class="accent--text">{{ $t("contact_data")|upper }}</h4>

              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("document_id") }}</b>
                </v-flex>
                <v-flex xs6>
                  {{ guest && guest.document_id }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("email") }}</b>
                </v-flex>
                <v-flex xs6>
                  {{ guest && guest.email }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("phone") }}</b>
                </v-flex>
                <v-flex xs6>
                  {{ guest && guest.phone }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("country") }}</b>
                </v-flex>
                <v-flex xs6>
                  <img :src="getCountryFlagUrl(guest && guest.country)" width="20px">
                  {{ guestCountryName }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("city") }}</b>
                </v-flex>
                <v-flex xs6>
                  {{ guest && guest.city }}
                </v-flex>
              </v-layout>


              <h4 class="mt-4 accent--text">{{ $t("reported_by")|upper }}</h4>
              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("hotel_name") }}</b>
                </v-flex>
                <v-flex xs6>
                  <a :href="getHotelUrl(guest)" target="_blank">{{ guest && guest.hotel_name }}</a>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("email") }}</b>
                </v-flex>
                <v-flex xs6>
                  {{ guest && guest.hotel_email }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("city") }}</b>
                </v-flex>
                <v-flex xs6>
                  <img :src="getCountryFlagUrl(guest && guest.hotel_country)" alt="guest.hotel_country" width="20px"> {{ guest && guest.hotel_city }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="secondary--text">
                  <b>{{ $t("date") }}</b>
                </v-flex>
                <v-flex xs6>
                  {{ guest && guest.created_at|date }}
                </v-flex>
              </v-layout>
            </v-flex>



            <v-flex xs12 md5 class="pa-4 blue-grey--text">
              <h4 class="accent--text">{{ $t("report_reasons")|upper }}</h4>
              <TagReasonsList :tags="guestTags"></TagReasonsList>

              <v-textarea class="mt-4"
                v-model="guestNote"
                full-width
                :rows="10"
                single-line
                readonly
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import * as utils from '../../utils'
  import TagReasonsList from '../components/TagReasonsList'

  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      guest: {
        required: true
      }
    },

    components: {
      TagReasonsList
    },

    data () {
      return {
      }
    },

    computed: {
      guestName () {
        if (this.guest === null || this.guest === undefined) {
          return ''
        }
        var s = this.guest.first_name
        if (this.guest.middle_name) {
          s += s.length > 0 ? ' ' : ''
          s += this.guest.midle_name
        }
        if (this.guest.last_name) {
          s += s.length > 0 ? ' ' : ''
          s += this.guest.last_name
        }
        return s
      },

      guestCountryName () {
        if (!this.guest) {
          return ''
        }
        return utils.getCountryName(this, this.guest.country)
      },

      guestNote () {
        if (!this.guest) {
          return ''
        }
        return this.guest.note
      },

      guestTags () {
        return !this.guest ? [] : this.guest.tags
      }
    },

    methods: {
      closeDialog (guest) {
        this.$emit('closeDialog', guest)
      },

      getCountryFlagUrl (code) {
        if (!this.guest) {
          return ''
        }
        return utils.getCountryFlagUrl(code)
      },

      getHotelUrl (guest) {
        if (!guest) {
          return ''
        }
        return utils.getHrefUrl(guest.hotel_url)
      }
    }
  }
</script>

<style scoped>
.compress_lines {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Guests/GuestDetail.vue